import { createI18n } from "vue3-i18n";
import enLocale from "./app-en";
import thLocale from "./app-th";

const messages = {
  en: enLocale,
  th: thLocale,
};

const i18n = createI18n({
  locale: "en",
  messages: messages,
});

export default i18n;
